<template>
   <v-text-field :rules="[rules.validate]" :masked="masked" v-mask="'(###) ###-####'"  v-model="selectedValue" @input="onSelect()">
                   <template slot="label"><span v-html="label" /></template>
    </v-text-field>     

</template> 

<style scoped>
.copy-phone {
  margin-left: 5px;
}
</style>
<script>
export default {
  props: [
    "masked",
    "label",
    "value",
    "dis",
    "copyfrom_sourcefield",
    "copyfrom_title",
    "onchangedcallbackparam"
  ],
  methods: {
    onSelect() {
      if (this.selectedValue == "") {
        this.$emit("input", this.selectedValue);
        this.$emit("DisableSave", false);
        return;
      }
      var isvalidphone = this.validatePhone();
      if (isvalidphone) {
        this.$emit("DisableSave", false);
        this.$emit("input", this.selectedValue.replace(/\D/g, ''));
      }else{
        this.$emit("DisableSave", true);
      }
      try {
        this.$emit("onchangedisvalidcallback", isvalidphone);
      } catch (e) {
        // ignore
      }
    },
    validatePhone() {
      if (!this.selectedValue || this.selectedValue == "") return true;
      var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
      return re.test(this.selectedValue);
    },
  },
  data() {
    return {
      selectedValue: this.value,
      rules: {         
          validate: value => {
            if(value != null && value != ''){
              const pattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
            return pattern.test(value) || 'Invalid Phone Number.'
            }else{
              return true;
            }
             
          },
        },
    };
  },
  computed: {
    isValidate() {
      return this.validatePhone();
    }
  },
  watch: {
    value(n, o) {
      this.selectedValue = n;
    }
  }
};
</script>
 